<template slot-scope="props">
  <div v-cloak>
    <div class="policy-basket--mobile">
      <div :class="[name === 'calculate-price' ? 'hide' : '']" class="row container hide-for-large">
        <div class="small-4 columns basket-price-label-mobile">
          <slot name="label-mobile"></slot>
        </div>
        <div class="small-8 columns total-price--mobile price">
          <span data-test="pricebox-mobile">{{ price }}</span>
          <small :class="{ hide: !price }">/år</small>
        </div>
        <slot name="basketsendoffermobile"></slot>
      </div>
    </div>
    <div class="row show-for-large">
      <div
        :class="[name === 'calculate-price' ? 'hide' : '']"
        class="small-12 medium-12 large-10 large-offset-2 columns"
      >
        <div>
          <div id="site-basket" class="callout">
            <h2 class="heading1">
              <slot name="label"></slot>
            </h2>
            <div class="total-price price">
              <span v-if="loading">
                <i class="spinner"></i>
              </span>
              <span data-test="pricebox-desktop">{{ price }}</span>
              <small :class="{ hide: !price }">/år</small>
            </div>
            <div v-if="priceInfo !== null" class="push-up" v-html="priceInfo"></div>
            <div>
              <!-- phBasketSendOffer -->
              <slot name="basketsendoffer"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'StickyBasket',
  props: {
    price: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    priceInfo: {
      type: String,
      default: null
    }
  }
});
</script>
